// Pre-launch: honest product promises, not invented testimonials.
const PROMISES = [
  { title: "A booking page you're proud to send", body: "Calm, on-brand, and unmistakably yours." },
  { title: "Held slots, honest availability", body: "No double-books. What's shown is what's true." },
  { title: "One link, every calendar", body: "Google and Microsoft, read together, always." },
  { title: "Team scheduling that just works", body: "Round-robin, collective, and group events." },
  { title: "Yours from day one", body: "Free to start, no credit card, keep your link forever." },
];

export function LandingTestimonials() {
  return (
    <section style={{ padding: "var(--lp-sec-y) 0", background: "var(--lp-ivory-2)" }}>
      <div className="lp-container">
        <span className="lp-eyebrow" data-reveal>What we're building</span>
        <h2 className="lp-h1" data-reveal style={{ marginTop: 12 }}>
          The promise, <em>in plain terms.</em>
        </h2>
        {/* CSS Grid (not multi-column): Safari mis-balances `columns` when the cards carry
            transform/opacity transitions (from the reveal + lift), dropping cards into fewer
            columns. A grid lays out identically across Chrome, Safari and Firefox. The
            auto-fit + minmax keeps it responsive: 3 across on wide, fewer as it narrows. */}
        <div
          data-reveal-group
          className="lp-promise-grid"
          style={{ marginTop: 38 }}
        >
          {PROMISES.map((p) => (
            <div
              key={p.title}
              className="lp-lift"
              data-reveal
              style={{
                background: "var(--lp-cream)",
                border: "1px solid var(--lp-border)",
                borderRadius: "var(--lp-radius-card)",
                padding: 24,
                boxShadow: "var(--lp-shadow-soft)",
              }}
            >
              <h3 style={{ fontFamily: "var(--lp-serif)", fontSize: 20, fontWeight: 500, margin: 0, color: "var(--lp-plum-900)" }}>
                {p.title}
              </h3>
              <p style={{ fontSize: 14, color: "var(--lp-plum-400)", margin: "10px 0 0" }}>{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
